import { find, get, map } from "lodash";
import cx from "classnames";
import styles from "./styles.module.scss";
import Actions from "src/components/actionbar";
import { SyncScrollLayout } from "../syncScrollLayout";
import { Account } from "src/types/accounts";
import { listOfDefaultViewers } from "src/types/settings/viewerSettings";

//Images
const ListViewerImage = '/images/settings/viewerSettings/list.png';
const ImmerseViewerImage = '/images/settings/viewerSettings/immerse.png';
const GalleryViewerImage = '/images/settings/viewerSettings/gallery.png';

type SelecteViewerType = {
    id: string;
    title: string;
    description: string;
    gif: string;
    imageOrder: number;
}

type DefaultViewerProps = {
  data: Account | {};
  handleChange?: (field: string, value: any) => void;
  showEditor: boolean;
  toggleEditor: () => void;
}

export const DefaultViewer = ({
   data,
   handleChange,
   showEditor,
   toggleEditor,
}: DefaultViewerProps) => {

    // configuration
    const viewerConfiguration = [
       {
        component: <ViewerRenderer src={ListViewerImage}/>,
       },
       {
        component: <ViewerRenderer src={ImmerseViewerImage}/>,
       },
       {
        component: <ViewerRenderer src={GalleryViewerImage}/>
       }
    ];

    const editorConfiguration = [
        {
         component: <EditorRenderer selectedViewer={ get(data, "librarySettings.assetViewer", "")} onChange={(viewerId) => {
           handleChange?.("librarySettings.assetViewer", viewerId);
          }}/>
        }
    ];

    return (
     <div className={styles.container}>
            <Actions.IconButton
                  icon={"paperflite-up-arrow"}
                  className={cx(styles.previewAction, { [styles.hide]: showEditor })}
                  onClick={() => {
                    toggleEditor();
                  }}
            />
                       
            <SyncScrollLayout 
                  viewerRenderer={viewerConfiguration}
                  editorRenderer={editorConfiguration}  
                  showEditor={showEditor}
                  animateEditorScroll={false}
                  defaultSelectedIndex={find<SelecteViewerType>( listOfDefaultViewers,
                    (viewer) => viewer.id === get(data, "librarySettings.assetViewer", ""))?.imageOrder || 0}
            />
    </div>
    );
}

export const ViewerRenderer = ({src}: {src:string}) => {
  return(
    <div className={styles.rendererContainer}>
         <img tabIndex={-1} src={src} alt=""/>
    </div>
  )
}

export const EditorRenderer = ({selectedViewer, onChange}: {selectedViewer: string, onChange: (viewerId: string) => void}) => {
    return (
    <div className={styles.editorRendersContainer}>
        <div className={styles.header}>
                <h5 className={styles.title}>Default Viewer</h5>
                <p className={styles.subText}>Choose the default viewer your recipients will see when you share content.</p>
        </div>
        {  map(listOfDefaultViewers, (viewer, index) => <>
              <ViewerCard
                  key={index}
                  title={viewer.title}
                  label={viewer.label}
                  src={viewer.gif}
                  isSelected={selectedViewer === viewer.id}
                  onChange={() => onChange(viewer.id)}
                  description={viewer.description}
                />
            </>)
        }
    </div>
    )
}

export const ViewerCard = ({title, src, label, onChange, isSelected, description}: {title: string, src:string, label: string, onChange: () => void, isSelected: boolean, description: string }) => {
    return(
        <div className={styles.viewerCardContainer} onClick={onChange}>
            <p className={cx(styles.title,  { [styles.primary]: isSelected })}>{title}</p>
            <div className={styles.innerContainer}>
                    <div className={cx(styles.imageWrapper)} >
                            <img tabIndex={-1} src={src} alt="" className={styles.gif} />
                            {isSelected && <span className={styles.activeImage}></span>}
                    </div>
                    <div className={styles.contentWrapper} >
                      <label tabIndex={-1} className={styles.radioWrapper} >
                                <i tabIndex={-1} className={cx(styles.checkbox, {
                                    "paperflite-radio-button-selected": isSelected,
                                    "paperflite-radio-button-unselected": !isSelected,
                                    [styles.primary]: isSelected,
                                })}
                                aria-hidden="true"
                                />
                                <span  className={cx(styles.radioLabel, {
                                    [styles.primary]: isSelected,
                                })}
                                >
                                {label}
                                </span>
                       </label>
                       <p dangerouslySetInnerHTML={{__html: description}} className={styles.description}></p>
                    </div>
            </div>
        </div>
    )
}